import { Box, Divider as MuiDivider, styled } from '@mui/material';

export const ButtonContainer = styled(Box)`
  padding: 0 25px 20px;
`;

export const Divider = styled(MuiDivider)`
  height: 1px;
  width: 95%;
  margin: 15px 0 0 15px;
`;
